import PhotosSelector from 'components/UI/V3/PhotosSelector';
import { VehiclePhoto } from '@spike/vehicle-model';
import { FunctionComponent } from 'react';
import styles from './PhotosSection.module.scss';

interface PhotosSectionProps {
    photos: Array<VehiclePhoto>;
    onChange?: (photos: Array<VehiclePhoto>) => void;
}

export const PhotosSection: FunctionComponent<PhotosSectionProps> = props => {
    return (
        <div className={styles.container}>
            <PhotosSelector
                title="Vehicle Photos"
                photos={props.photos}
                showCoverTag={true}
                maxPhotos={10}
                multipleSelection={true}
                onChange={props.onChange}
            />
        </div>
    );
};

export default PhotosSection;
